const ClearableInput = {
  mounted() {
    this.input = this.el.querySelector('input')
    this.clearBtn = this.el.querySelector('.clear-btn')
    
    if (!this.input || !this.clearBtn) return
    
    // Show/hide clear button based on input content
    this.updateClearButton()
    
    // Listen for input changes
    this.input.addEventListener('input', () => {
      this.updateClearButton()
    })
    
    // Handle clear button click
    this.clearBtn.addEventListener('click', (e) => {
      e.preventDefault()
      this.input.value = ''
      this.updateClearButton()
      // Trigger input event to notify LiveView
      this.input.dispatchEvent(new Event('input', { bubbles: true }))
      this.input.focus()
    })
  },
  
  updated() {
    this.updateClearButton()
  },
  
  updateClearButton() {
    if (!this.input || !this.clearBtn) return
    
    if (this.input.value.trim() !== '') {
      this.clearBtn.style.display = 'block'
    } else {
      this.clearBtn.style.display = 'none'
    }
  }
}

export default ClearableInput